import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import * as R from 'ramda'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { compose } from 'redux'
import { toggleDropBox, fetchHistory } from '../../actions'
import {TOGGLE_HISTORY_SUCCESS} from '../../actionTypes'
import dateFormat from 'dateformat'
import HistoryItem from '../../components/HistoryItem'
import Icon from '@material-ui/core/Icon';


class History extends Component {

    constructor(props){
        super(props);

        this.myRef = []
    }

    componentDidMount(){
        const { id } = this.props.ownProps.params

        this.props.fetchHistory(id)

    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.history !== this.props.history) {
            /*console.log(this.inputElement)
            setTimeout(()=> {
                let firstElement = document.getElementById('comment__element_1-new')
                let parent = document.querySelector('.comment__content_history')
                let commentNewHint = document.querySelector('.comment__new-hint')
                if(commentNewHint){
                    //removeElements( document.querySelectorAll(".comment__new-hint") );
                }
                if(firstElement){
                   /!* setTimeout(() => {
                        console.log(this.firstNewElement)
                        if(this.firstNewElement){
                        }
                        //console.log(firstElement.offsetTop - 120)

                    },3000)*!/
                        setTimeout(() => {
                            console.log(firstElement)
                            firstElement.scrollIntoView({block: "start"});
                        },100)

                    /!* var div = document.createElement("div");
                     div.className = 'comment__new-hint'
                     div.innerHTML = 'Unread'
                     firstElement.appendChild(div)*!/
                }else{
                    this.handleScroll()
                }
            })*/
        }

        const id = nextProps.ownProps.params.id;


        if (id !== this.props.ownProps.params.id) {


        }


    }


    handleScroll (){
        this.content.scrollIntoView({block: "end"});

    }




    render() {
        const { dropBox, history, user } = this.props
        const listKey = this.props.ownProps.params.id
        const lines = this.props.lines
        const tags = this.props.tags
        const dropClass = classNames({
            'comment': true,
            'active': dropBox.history
        });
        const closeDropComments = () => {
            this.props.toggleDropBox(TOGGLE_HISTORY_SUCCESS)
        }
        let newHistoryCount = 0

        setTimeout(() => {
            let firstElement = document.getElementById('comment__element_1-new')
            if(firstElement){
                firstElement.scrollIntoView({block: "start"});

            }else{
                this.content && this.handleScroll()
            }

            console.log('firstElement', firstElement)
        }, 300)


        return (
            <div className={dropClass}>
                <div className="comment__wrap">
                    <div className="comment__header">
                        <div className="comment__title comment__title_no-link">
                            History
                        </div>

                        <div className="comment__close" onClick={closeDropComments}>
                            <Icon>arrow_right_alt</Icon>
                        </div>
                    </div>

                    <div className="comment__content comment__content_history" >
                        <div ref={input => this.content = input}>
                            {
                                history && history.map((item, i) => {
                                    let newHistory = user.historyTime && user.historyTime.oldDate < item.time && item.userId !== user.id
                                    newHistory && newHistoryCount ++

                                    if(lines[item.keyLine] || (item.type === 'tags' && !R.isEmpty(tags))) {
                                        return <HistoryItem
                                            newHistoryCount={newHistoryCount}
                                            newHistory={newHistory}
                                            user={user}
                                            index={i+1}
                                            key={i}
                                            tags={tags}
                                            line={lines[item.keyLine]}
                                            data={item} />
                                    }
                                        /*<div key={item.time} className="comment__element">
                                            <div className="comment_name">{item.description}</div>
                                            <div className="comment__text" dangerouslySetInnerHTML={{__html: item.description}}></div>
                                            <div className="comment__block-bottom">
                                                <div className="comment__date">{ dateFormat(item.time, "dddd, mmmm dS, yyyy, h:MM:ss TT") }</div>
                                            </div>
                                        </div>*/
                                })
                            }
                        </div>
                    </div>
                </div>

             </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    dropBox: state.dropBox,
    history: state.history,
    lines: state.lines,
    tags: state.tags,
    user: state.user,
    ownProps
})

const mapDispatchToProps = {
    toggleDropBox,
    fetchHistory
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(History)


// WEBPACK FOOTER //
// ./src/containers/drop/History.js